import { MiniCartController } from './miniCartController.js';

var cartController = new MiniCartController();

// eslint-disable-next-line no-unused-vars
document.addEventListener('DOMContentLoaded', function (event) {
  cartController.init();
});

// If loaded from cache cart might not reflect current cart state, so re init()
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    cartController.init();
  }
});
